<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content" v-if="initialized">
            <rednax-datatable
                :url="'/vue/invoices/payments'"
                :columns="table_columns"
                sort-by="PaymentDate"
                sort-order="desc"
                :row-class="(row) => row.isReminded > 0 ? ['bg-danger-200', 'font-weight-bold'] : []"
            >
<!--                <div class="row">-->
<!--                    <div class="col-12 col-lg-4 col-xl-2">-->
<!--                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">-->
<!--                    </div>-->
<!--                    <div class="col-12 col-lg-4 col-xl-4">-->
<!--                        <v-date-picker-->
<!--                            v-model="table_filter.date"-->
<!--                            mode="date"-->
<!--                            :locale="{ id: 'sv', firstDayOfWeek: 2, masks: { weekdays: 'WW', input: 'YYYY-MM-DD' } }"-->
<!--                            :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"-->
<!--                            is-range-->
<!--                            show-iso-weeknumbers-->
<!--                        >-->
<!--                            <template v-slot="{ inputValue, inputEvents }">-->
<!--                                <div class="row">-->
<!--                                    <b-col style="position:relative;">-->
<!--                                        <div class="input-group">-->
<!--                                            <span class="input-group-prepend">-->
<!--                                                <span class="input-group-text">-->
<!--                                                    <i class="icon-calendar2"></i>-->
<!--                                                </span>-->
<!--                                            </span>-->
<!--                                            <input-->
<!--                                                class="form-control"-->
<!--                                                :value="(inputValue.start && inputValue.end ? inputValue.start + ' - ' + inputValue.end : '')"-->
<!--                                                v-on="inputEvents.start"-->
<!--                                                placeholder="Datumintervall..."-->
<!--                                            />-->
<!--                                            <span class="input-group-append">-->
<!--                                                <button type="button" class="btn btn-light px-2" @click="table_filter.date = null">-->
<!--                                                    <i class="icon-cross"></i>-->
<!--                                                </button>-->
<!--                                            </span>-->
<!--                                        </div>-->
<!--                                    </b-col>-->
<!--                                </div>-->
<!--                            </template>-->
<!--                        </v-date-picker>-->
<!--                    </div>-->
<!--                </div>-->
                <template #cell_InvoiceID="{ row }">
                    <router-link :to="{ name: 'invoice.edit', params: { id: row.InvoiceID } }">{{ row.ocr }}</router-link>
                </template>
                <template #cell_OrderID="{ row }">
                    <router-link :to="{ name: 'cardorders.edit', params: { id: row.OrderID } }">{{ row.OrderID }}</router-link>
                </template>
                <template #cell_CompanyName="{ row }">
                    <router-link :to="{ name: 'customers.edit', params: { id: row.CustomerID } }">{{ row.CompanyName }}</router-link>
                </template>
                <template #cell_Amount="{ row }">
                    {{ formatNumber(row.Amount, 2) }} {{ (row.CurrencyShort ? row.CurrencyShort : 'SEK') }}
                </template>
                <template #cell_PaymentDate="{ row }">
                    {{ row.PaymentDate.substring(0, 10) }}
                </template>
                <template #cell_Days="{ row }">
                    {{ row.Days }}
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatNumber } from '@services/Helpers';
// import VDatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
    components: {
        // VDatePicker,
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        initialized: false,
        table_filter: {
            search: '',
            date: null,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        formatNumber,
        init() {
            const today = new Date();
            const dateStart = new Date().setDate(today.getDate() - 14);

            this.table_filter.date = {
                start: dateStart.toLocaleString('sv-SE')
                    .substring(0, 10),
                end: today.toLocaleString('sv-SE')
                    .substring(0, 10),
            };
            this.initialized = true;
        },
    },
    computed: {
        table_columns() {
            return [
                {
                    header: 'OCR',
                    data: 'InvoiceID',
                    sortable: true,
                },
                {
                    header: 'OrderNr',
                    data: 'OrderID',
                    sortable: true,
                },
                {
                    header: 'Kund',
                    data: 'CompanyName',
                    sortable: true,
                },
                {
                    header: 'Fakturadatum',
                    data: 'InvoiceDate',
                    sortable: true,
                },
                {
                    header: 'Förfallodatum',
                    data: 'ExpireDate',
                    sortable: true,
                },
                {
                    header: 'Betaldatum',
                    data: 'PaymentDate',
                    sortable: true,
                },
                {
                    header: 'Inbetalt',
                    data: 'Amount',
                    sortable: true,
                    align_right: true,
                },
                {
                    header: 'Dagar',
                    data: 'Days',
                    sortable: true,
                    align_right: true,
                },
            ];
        },
    },
};

</script>
